// Class: haxe.xml._Fast.AttribAccess

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $import = require("./../../../import_stub").default;
function Xml() {return require("./../../../Xml");}
function js__$Boot_HaxeError() {return require("./../../../js/_Boot/HaxeError");}

// Constructor

var AttribAccess = function(x) {
	this.__x = x;
}

// Meta

AttribAccess.__name__ = ["haxe","xml","_Fast","AttribAccess"];
AttribAccess.prototype = {
	resolve: function(name) {
		if(this.__x.nodeType == (Xml().default).Document) {
			throw new (js__$Boot_HaxeError().default)("Cannot access document attribute " + name);
		}
		var v = this.__x.get(name);
		if(v == null) {
			throw new (js__$Boot_HaxeError().default)(this.__x.get_nodeName() + " is missing attribute " + name);
		}
		return v;
	}
};
AttribAccess.prototype.__class__ = AttribAccess.prototype.constructor = $hxClasses["haxe.xml._Fast.AttribAccess"] = AttribAccess;

// Init



// Statics




// Export

exports.default = AttribAccess;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/haxe/xml/_Fast/AttribAccess.js
// module id = 312
// module chunks = 0